import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bedding-mix-calculator',
  templateUrl: './bedding-mix-calculator.component.html',
  styleUrls: ['./bedding-mix-calculator.component.scss']
})
export class BeddingMixCalculatorComponent implements OnInit {

  constructor() { }

  mortar: number;
  defaultMortar:boolean;
  totalSqm: number;
  defaultMortarValue = 50;
  G28 = 0.015;
  total25Kgsbags :number;
  total800Kgsbags :number;
  total1000Kgsbags :number;

 

  ngOnInit(): void {
  }

  materialCostChange(searchValue): void {  

    if(this.defaultMortar == true){
      this.mortar = this.defaultMortarValue;
    }
   

    this.calculateMaterialDesign();
   
  }

  calculateMaterialDesign(){

    let A28 = this.totalSqm;
    let B28 = this.mortar;

   

    let M3 = A28*(B28/1000);

   

    let volumeOf1KgBags = this.G28/25;

    
    let  volumeOf25KgBags= volumeOf1KgBags*25;
   let  volumeOf800KgBags= volumeOf1KgBags*800;
    let volumeOf1000KgBags = volumeOf1KgBags*1000;

   

    this.total25Kgsbags = Math.ceil(M3/volumeOf25KgBags);
    this.total800Kgsbags = Math.ceil(M3/volumeOf800KgBags);
    this.total1000Kgsbags= Math.ceil(M3/volumeOf1000KgBags);
    
 
  }

}
